import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
    flexWrap: 'wrap',
    mt: ['0', null, '1'],
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'alpha.500',
    width: 'fit-content',
    borderRadius: 'md',
    px: '2',
    py: '2',
    my: '1',
    mr: ['1', '3'],
    color: 'white',
    fontWeight: 'semibold',
    fontSize: 'xs',
  },
  priceTitle: {
    as: 'p',
    color: 'white',
    fontWeight: 'semibold',
    fontSize: ['2xs', 'xs'],
    mr: '1',
  },
  priceText: {
    color: 'white',
    mr: ['1', '2'],
    fontSize: ['2xs', 'xs'],
    display: 'flex',
    alignItems: 'center',
  },
  priceTextIncreased: {
    color: 'white',
  },
  priceIcon: {
    color: 'red.500',
    ml: '1',
  },
  priceIconIncreased: {
    color: 'alpha.200',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '10',
    borderLeft: '1px solid',
    borderColor: ['transparent', null, 'blackAlpha.300'],
    ml: '1',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
